/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useMemo } from 'react';

import { Button } from '@components';

import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { format, parse } from 'date-fns';
import { DadosUsuarioSchema } from '@schemas';
import { DadosPessoais } from '../../../../MeusDados/components/DadosPessoais';
import { Contato } from '../../../../MeusDados/components/Contato';
import { Residenciais } from '../../../../MeusDados/components/Residenciais';
import { DadosBancarios } from '../../../../MeusDados/components/DadosBancarios';
import { setDadosPessoaisRequerimento } from '../../../../../store/requerimentos/slice';
import { banks } from '../../../../../common/utils/banks';

export const DadosUsuario = ({ onClick, dadosBancarios = false }) => {
  const dispatch = useDispatch();
  const { dadosSAPNaoTratados, dadosPessoais } = useSelector(
    (state) => state.user
  );

  const isBancoValido = banks.some((b) => b.codigo === dadosPessoais.codBanco);
  const bancoValido = isBancoValido ? dadosPessoais.codBanco : '';

  const [initialState, setInitialState] = useState({
    ...dadosSAPNaoTratados,
    dtNascimento: dadosSAPNaoTratados.dtNascimento
      ? format(
          parse(dadosSAPNaoTratados.dtNascimento, 'yyyy-MM-dd', new Date()),
          'dd/MM/yyyy'
        )
      : 'dd/MM/yyyy',
    banco: bancoValido,
    agencia: dadosPessoais.agencia,
    conta: dadosPessoais.conta,
    digito: dadosPessoais.digitoConta,
  });

  useEffect(() => {
    setInitialState({
      ...dadosSAPNaoTratados,
      dtNascimento: dadosSAPNaoTratados.dtNascimento
        ? format(
            parse(dadosSAPNaoTratados.dtNascimento, 'yyyy-MM-dd', new Date()),
            'dd/MM/yyyy'
          )
        : 'dd/MM/yyyy',
      estadoCivil:
        dadosSAPNaoTratados.estadoCivil === 'Outros'
          ? ''
          : dadosSAPNaoTratados.estadoCivil,
      banco: bancoValido,
      agencia: dadosPessoais.agencia,
      conta: dadosPessoais.conta,
      digito: dadosPessoais.digitoConta,
    });
  }, [dadosSAPNaoTratados, dadosPessoais, bancoValido]);

  const validationSchema = useMemo(() => {
    return dadosBancarios
      ? DadosUsuarioSchema
      : DadosUsuarioSchema.omit(['banco', 'agencia', 'conta', 'digito']);
  }, [dadosBancarios]);

  return (
    <Formik
      enableReinitialize
      initialValues={initialState}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        dispatch(
          setDadosPessoaisRequerimento({
            dtNascimento: format(
              parse(values.dtNascimento, 'dd/MM/yyyy', new Date()),
              'yyyy-MM-dd'
            ),
            estadoNasc: values.estadoNasc,
            localNascimento: values.localNascimento,
            nacionalidade: values.nacionalidade,
            sexo: values.sexo,
            estadoCivil: values.estadoCivil,
            pai: values.pai,
            mae: values.mae,
            rg: values.rg,
            endereco: values.endereco,
            numero: values.numero,
            complemento: values.complemento,
            cep: values.cep,
            bairro: values.bairro,
            cidade: values.cidade,
            estado: values.estado,
            email: values.email,
            celular: values.celular,
            telefoneFixo: values.telefoneFixo,
            banco: values.banco,
            agencia: values.agencia,
            conta: values.conta,
            digito: values.digito,
          })
        );

        onClick();
      }}
    >
      {({ handleSubmit, isValid }) => (
        <form onSubmit={handleSubmit}>
          <DadosPessoais />
          <Contato />
          <Residenciais />
          {dadosBancarios && <DadosBancarios />}
          <div className="row mt-4">
            <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
              <div className="d-block d-md-flex align-items-center">
                <Button disabled={!isValid} type="submit">
                  Continuar
                </Button>
              </div>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
};
